import React from 'react';
import { useNavigate } from 'react-router-dom';
import ContactData from '../contact-data';
import ProgressLabel from '../progress-label';
import { Element, ContainerProgress } from './styles';

const Unit = ({ item }) => {
  const navigate = useNavigate();

  const handleNavigate = (id) => {
    navigate(`/prefeitura/secretaria/unidade/${id}`);
  };

  return (
    <Element onClick={() => handleNavigate(item.id)} id={`unit-card-${item.id || 'unknown'}`}>
      <ContainerProgress id={`unit-progress-${item.id || 'unknown'}`}>
        <ProgressLabel amount={item.compliance?.maturity || 0} />
      </ContainerProgress>
      <h1 id={`unit-name-${item.id || 'unknown'}`}>{item.name}</h1>
      <small id={`unit-responsible-${item.id || 'unknown'}`}>{item.responsible?.name || 'N/A'}</small>
      <div id={`unit-contact-${item.id || 'unknown'}`}>
        {item.responsible?.email && (
          <ContactData contact={item.responsible.email} />
        )}
      </div>
    </Element>
  );
};

export default Unit;
